import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ConfigurationService } from './COMMON/services/configuration.service';
import { AnalyticsCMSEffects } from './store/CMS/analytics-CMS.effects';

@NgModule({
    imports: [
        EffectsModule.forFeature([AnalyticsCMSEffects]),
    ],
    providers: [ConfigurationService],
})
export class AnalyticsCMSModule { }
